import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-200">
      <div className="container mx-auto px-4 py-12 max-w-6xl">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img
              src="/logos/Icono-Purple.png"
              alt=""
              className="h-10 w-auto"
            />
            <div className="text-center lg:text-left space-y-2">
              <p className="text-lg">
                Creado por{' '}
                <a
                  href="https://codigoenblanco.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-rose-400 font-semibold hover:text-rose-300 transition-colors"
                >
                  Código En Blanco
                </a>
              </p>
              <p className="text-gray-400">
                © 2025 Código En Blanco. Transformamos ideas en soluciones tecnológicas.
              </p>
            </div>
          </div>
          <div className="text-center lg:text-right">
            <p className="text-sm uppercase tracking-[0.3em] text-gray-400 mb-2">Conecta con nosotros</p>
            <a
              href="https://www.linkedin.com/company/c%C3%B3digoenblanco/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-gray-700 hover:border-rose-400 text-gray-200 hover:text-white transition-colors"
              aria-label="LinkedIn Código En Blanco"
            >
              <span className="font-semibold">LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
